module.exports = __webpack_public_path__ + "static/media/pharynx.da6d1bcc.ogg";